import { useQuery } from "react-query";
import { useDispatch } from "react-redux";

import { getDefaultValuesForPaymentMethodForm } from "components/pages/paymentMethods/paymentMethodForm/getDefaultValuesForPaymentMethodForm";
import { getErrorMessage } from "helpers";
import { merchantPaymentsService } from "services";
import { uiActions } from "store";
import { ErrorResponse } from "types";

const useGetMerchantPaymentMethod = ({
	tab,
	fetchData,
	merchantId,
}: {
	fetchData: { page: number; filters: any; sortBy: { [key: string]: any } };
	tab: string;
	merchantId: any;
}) => {
	const dispatch = useDispatch();
	const { page, sortBy } = fetchData;
	const queryResult = useQuery(
		["getMerchantPaymentMethod", tab, page, sortBy],
		() =>
			merchantPaymentsService.getMerchantPaymentMethod({
				page,
				sortBy,
				merchantId,
			}),
		{
			select: (data: any) => {
				return {
					...data,
					items: data?.items?.map(x =>
						getDefaultValuesForPaymentMethodForm(x, "MM"),
					),
				};
			},
			onError(error: ErrorResponse) {
				dispatch(
					uiActions.showErrorNotification({
						title: getErrorMessage(error),
					}),
				);
			},
			cacheTime: 0,
		},
	);

	return queryResult;
};

export default useGetMerchantPaymentMethod;
